import { getKiosksWithoutAllJobs, verifyIfUserIsAdmin, getLogMonoCaseByPagination, getKiosksNames, getLogEnergyCardByPagination } from '@/services/RequestService.js';
import { convertArrayToObject } from '@/utils/ConvertListToObject.js';
import { getRandomColor } from '@/utils/RandomColor.js';
import { getAllTags, getKiosksWithTags } from "@/services/TagsService.js";
import { getkioskOwnerArray } from "@/services/ExtranetInfosService";
import { getKiosksListAsked, getKiosksCheckHistory } from '../services/RequestService';

/**
 * Every ten seconds
 */
const GET_KIOSKS_INTERVAL = 1000 * 10;
/**
 * Every twenty seconds
 */
const GET_EXTRANET_INFOS_INTERVAL = 1000 * 20;

var store = {
    debug: false,
    /**
     * Save for the tag's color
     * We add a empty tag in the front for allows to select nothing in the field. 
     */
    tagsList: [{id: 0, name: "", isPrivate: false}],
    /**
     * Save the list of the lastcheck history of the selected kiosks
     */
    checkHistoryList:[],
    state: {
        tags: [],
        kiosksWithTags: [],
        kioskOwner: [],
        listOfKiosks: [],
        dictOfKiosks: {},
        selectedKiosks: [],
        kioskTimer: {},
        extranetTimer: {},
        isCurrentUserAdmin:false,
        currentUsername: localStorage.getItem("user"),
        afficher:[],
        jobs:[],
        autoDiagJobs: [],
        isLoading: false,
        log: {},
        logEnergyCard:{},
        kiosksNames:[],
    },
  
    mutations: {
        SET_LOADING(state, value) {
            state.isLoading = value;
        },
    },
    actions: {
        setLoading({ commit }, value) {
            commit('SET_LOADING', value);
        },
    },
    getters: {
        isLoading: (state) => state.isLoading,
    },

    assignColorToTag(name) {
        if (this.tagsList != undefined || this.tagsList.length != 0) {
            let index = this.tagsList.find(element => element.name == name)
            if (index != undefined)
                return (index.color);
        }
        let newColor = getRandomColor()
        this.tagsList.push({name :name, color: newColor})
        return (newColor)

    },
    clearIntervalsTimer() {
        clearInterval(this.kioskTimer);
        clearInterval(this.extranetTimer);
    },
    async updateCheckHistoryList() {
        let nameList = '[';
        for (let index in this.state.selectedKiosks) {
            nameList += '"' + this.state.selectedKiosks[index].name + '",';
        }
        if (nameList.charAt(nameList.length - 1) == ',') nameList = nameList.slice(0, -1);
        nameList += ']';


        let receivedSelectedKiosks = await getKiosksListAsked(nameList);

        if (receivedSelectedKiosks && receivedSelectedKiosks.length > 0) {
            // Copier selectedKiosks depuis l'état
            let kiosktmp = [...this.state.selectedKiosks];

            if (kiosktmp.length > 0 && kiosktmp[0].id === receivedSelectedKiosks[0]._id) {
                // S'assurer que le champ jobsFlag existe dans kiosktmp[0]
                if (!kiosktmp[0].jobsFlag) {
                    kiosktmp[0].jobsFlag = {};
                }
                // Mettre à jour jobsFlag avec les données de tmp[0]
                kiosktmp[0].jobsFlag = receivedSelectedKiosks[0]?.jobsFlag || kiosktmp[0].jobsFlag;
                this.setSelectedKiosks(kiosktmp);
            }
        }
        // Mettre à jour l'état
        this.setCheckHistoryList(await getKiosksCheckHistory(nameList));
    },
    async firstCallAndLaunchIntervals() {
        this.clearIntervalsTimer();
        this.setIsCurrentUserAdmin(await verifyIfUserIsAdmin());
        let receivedKiosks = await getKiosksWithoutAllJobs(true); 
        this.setKiosks(receivedKiosks);
        this.refreshExtranetInfos();
        /*this.setAutoDiagJobs(await getLastAutoDiagJobs());
        this.refreshExtranetInfos();
        this.setJobs(await getListLastJobs())
        this.refreshSelectedKiosksInfos(receivedKiosks);
        this.funct();*/

        //this.launchStoreRefreshIntervals()
    },
    //Version of launchStoreRefreshIntervals() without Timer
    async funct(){
    
    },
    launchStoreRefreshIntervals() {
        //get kiosks interval
        this.kioskTimer = setInterval(
            async () => {
                
            }
            , GET_KIOSKS_INTERVAL)

        //get kiosks interval
        this.extranetTimer = setInterval(
            async () => {

                this.refreshExtranetInfos();
            }
            , GET_EXTRANET_INFOS_INTERVAL)
    },
    
    /*async getLogMonoCaseByPagination(page, limit, filter) {
        let logList = await getLogMonoCaseByPagination(page, limit, filter);
        this.setLogMonocase(logList);
    },*/

    async getLogMonoCaseByPagination(page, limit, filter, sortBy = null, sortDesc = false) {
        let logList = await getLogMonoCaseByPagination(page, limit, filter, sortBy, sortDesc);
        this.setLogMonocase(logList);
    },

    async getLogEnergyCardByPagination(page, limit, filter, sortBy = null, sortDesc = false) {
        let logList = await getLogEnergyCardByPagination(page, limit, filter, sortBy, sortDesc);
        this.setLogEnergyCard(logList);
    },
    async getKiosksNames() {
        let kioskNameList = await getKiosksNames();
        this.setKiosksNames(kioskNameList);
    },

    async refreshExtranetInfos() {
        let allTagsPromise = getAllTags();
        let kiosksWithTagsPromise = getKiosksWithTags();
        let kioskOwner = getkioskOwnerArray();
        
        await Promise.all([allTagsPromise, kiosksWithTagsPromise, kioskOwner]).then(async (val) => {
            console.log("all tags promise", val[0]);
            console.log("kiosksWithTagsPromise", val[1]);
            console.log("kioskOwner", val[2]);
            this.setKiosksWithTags(val[1]);
            this.setTags(val[0]);
            this.setKioskOwner(val[2]);
        })
    },

    async refreshSelectedKiosksInfos(updatedKiosks) {
        let kioskLikeInMainTable = updatedKiosks.map((e) => {
            return {
                id: e._id,
                idExtranet: e.idExtranet,
                macAddr: e.macAddress,
                name: e.name,
                vpnAddress: e.vpnAddress,
                etat:e.etat,
                //warning miss lastCheck if needed for other features.
                tags:
                    this.state.kiosksWithTags[e.idExtranet] !== undefined
                        ? this.state.kiosksWithTags[e.idExtranet].tags
                        : null,
                kioskOwner: this.state.kioskOwner[e.idExtranet] !== undefined ?
                    this.state.kioskOwner[e.idExtranet].owner : null,
            };
        });


        // we want to refresh infos only if needed ==> one kiosk selected
        if (this.state.selectedKiosks.length == 1) {
            let listOfOneKiosk = []

            let tmp = kioskLikeInMainTable.find(e => e.id === this.state.selectedKiosks[0].id);

            listOfOneKiosk.push(tmp)

            this.setSelectedKiosks(listOfOneKiosk);

        }

    },

    
    resetSessionInfos(){
        this.setIsCurrentUserAdmin(false);
        this.setCurrentUsername=("Unknown");
    },

    setTags(newValue) {
        if (this.debug) console.log('setTags déclenchée avec', newValue)
        this.state.tags = convertArrayToObject(
            newValue.map(e => {
                return {
                    id: e.id,
                    name: e.name,
                    isPrivate: e.isPrivate,
                    color: this.assignColorToTag(e.name)
                };
            }), "id")
    },

    setCheckHistoryList(newValue) {
        if (this.debug) console.log('setCheckHistoryList déclenchée avec', newValue)
        this.checkHistoryList = newValue;
    },

    setKiosksWithTags(newValue) {
        if (this.debug) console.log('setKiosksWithTags déclenchée avec', newValue)
        this.state.kiosksWithTags = convertArrayToObject(
            newValue, "id");
    },
    setKioskOwner(newValue) {
        if (this.debug) console.log('setKioskOwner déclenchée avec', newValue)
        this.state.kioskOwner = convertArrayToObject(
            newValue, "id");
    },
    setKiosks(newValue) {
        if (this.debug) console.log('setKiosks déclenchée avec', newValue)
        this.state.listOfKiosks = newValue
        this.state.dictOfKiosks = convertArrayToObject(newValue, "_id")
    },
    setJobs(newValue) {
        if (this.debug) console.log('setJobs déclenchée avec', newValue)  
        this.state.jobs = newValue        
    },
    setAutoDiagJobs(newValue) {
        if (this.debug) console.log('setJobs déclenchée avec', newValue)  
        this.state.autoDiagJobs = newValue        
    },
    setSelectedKiosks(newValue) {
        if (this.debug) console.log('setSelectedKiosks déclenchée avec ', newValue)
        this.state.selectedKiosks = newValue
    },
    setIsCurrentUserAdmin(newValue){
        if (this.debug) console.log('setIsCurrentUserAdmin déclenchée avec ', newValue)
        this.state.isCurrentUserAdmin = newValue
    },
    setCurrentUsername(newValue){
        if (this.debug) console.log('setCurrentUsername déclenchée avec ', newValue)
        localStorage.setItem("user", newValue);
        this.state.currentUsername=localStorage.getItem("user");
    },
    setAfficher(newValue){
        this.state.afficher=newValue;
    },
    setLogMonocase(newValue){
        console.log('setLogMonocase déclenchée avec', newValue);
        this.state.log = newValue;
    },
    setLogEnergyCard(newValue) {
        console.log('setLogEnergyCard déclenchée avec', newValue);
        this.state.logEnergyCard = newValue;
    },
    setKiosksNames(newValue) {
        console.log('setKiosksNames déclenchée avec', newValue);
        this.state.kiosksNames = newValue;
    },

}

export {
    store,
};
